import { LogoSelector } from "./components/LogoSelector";
import { PdfGenerator } from "./components/PdfGenerator";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { useI18n } from '@/hooks/useI18n';
import { Info } from "lucide-react";

interface SendQuoteStep2Props {
    logoChoice: 'own' | 'agency' | null;
    onLogoChoiceChange: (value: 'own' | 'agency') => void;
    hasOwnLogo: boolean;
    hasAgencyLogo: boolean;
    ownLogoUrl?: string | null;
    ownLogoSmallUrl?: string | null;
    agencyLogoUrl?: string | null;
    agencyLogoSmallUrl?: string | null;
    isPdfGenerating: boolean;
    pdfBase64: string | null;
    pdfFilename: string | null;
    pdfError: string | null;
    onGeneratePdf: () => void;
    onPreviewPdf: () => void;
    includePdf: boolean;
    onIncludePdfChange: (value: boolean) => void;
}

export const SendQuoteStep2 = ({
    logoChoice,
    onLogoChoiceChange,
    hasOwnLogo,
    hasAgencyLogo,
    ownLogoUrl,
    ownLogoSmallUrl,
    agencyLogoUrl,
    agencyLogoSmallUrl,
    isPdfGenerating,
    pdfBase64,
    pdfFilename,
    pdfError,
    onGeneratePdf,
    onPreviewPdf,
    includePdf,
    onIncludePdfChange
}: SendQuoteStep2Props) => {
    const { t } = useI18n();
    const hasLogoSelected = logoChoice !== null;

    return (
        <div className="space-y-6">
            {/* Prima la domanda, come per la mail: il resto serve solo se si allega */}
            <div className="flex items-start space-x-3 p-4 border rounded-lg bg-gray-50">
                <Checkbox
                    id="include-pdf"
                    checked={includePdf}
                    onCheckedChange={(v) => onIncludePdfChange(v === true)}
                    className="mt-0.5"
                />
                <div className="flex-1">
                    <Label
                        htmlFor="include-pdf"
                        className="text-sm font-medium cursor-pointer"
                    >
                        {t('itinerary.includePdf')}
                    </Label>
                    <p className="text-xs text-gray-500 mt-1 flex items-start gap-1">
                        <Info className="h-3 w-3 mt-0.5 flex-shrink-0" />
                        <span>{t('itinerary.includePdfDescription')}</span>
                    </p>
                </div>
            </div>

            {/* Il logo va anche nell'intestazione della mail: si sceglie comunque */}
            <LogoSelector
                logoChoice={logoChoice}
                onLogoChoiceChange={onLogoChoiceChange}
                hasOwnLogo={hasOwnLogo}
                hasAgencyLogo={hasAgencyLogo}
                ownLogoUrl={ownLogoUrl}
                ownLogoSmallUrl={ownLogoSmallUrl}
                agencyLogoUrl={agencyLogoUrl}
                agencyLogoSmallUrl={agencyLogoSmallUrl}
                isPdfGenerating={isPdfGenerating}
            />

            {includePdf && hasLogoSelected && (
                <div className="pt-2 border-t animate-in fade-in duration-300">
                    <PdfGenerator
                        isPdfGenerating={isPdfGenerating}
                        pdfBase64={pdfBase64}
                        pdfFilename={pdfFilename}
                        pdfError={pdfError}
                        onGeneratePdf={onGeneratePdf}
                        onPreviewPdf={onPreviewPdf}
                        generateDisabled={false}
                    />
                </div>
            )}
        </div>
    );
};
